import { render } from "./TradePassport.vue?vue&type=template&id=5b52a9c2&scoped=true&ts=true"
import script from "./TradePassport.vue?vue&type=script&lang=ts"
export * from "./TradePassport.vue?vue&type=script&lang=ts"

import "./TradePassport.vue?vue&type=style&index=0&id=5b52a9c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b52a9c2"]])

export default __exports__